import styled from 'styled-components';

export const WidgetWrapper = styled.div`
  width: 100%;
  background: white;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors.black4};

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    width: 60%;
  }
`;

export const TitleWrapper = styled.h2`
  font-size: 18px;
  font-weight: 600;
  margin: 0;
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  align-self: stretch;
  flex-direction: column;
  align-items: center;
`;

export const TitleAndLegendWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    flex-direction: row;
    align-items: center;
  }
`;
